import { render } from "./Testimonial4Content.vue?vue&type=template&id=ec71ee22&scoped=true&ts=true"
import script from "./Testimonial4Content.vue?vue&type=script&lang=ts"
export * from "./Testimonial4Content.vue?vue&type=script&lang=ts"

import "./Testimonial4Content.vue?vue&type=style&index=0&id=ec71ee22&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec71ee22"]])

export default __exports__